import { Col, Form, Row } from "react-bootstrap";
import { useFormikContext } from "formik";
import FormLabel from "../../../Text/FormLabel";
import ReactInput from "../../../InputList/ReactInput/ReactInput";
import ReactTextEditor from "../../../Editors/ReactTextEditor";
import StatusCheck from "../../StatusCheck";

const AboutUsForm = () => {
  const { values, setFieldValue } = useFormikContext();
  return (
    <Row>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Title" required />
          <ReactInput name="title" />
        </Form.Group>
      </Col>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Side Image Right" required />
          <ReactInput name="side_img" type="file" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Side Image Left" required />
          <ReactInput name="middle_img" type="file" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Why Choose Us Logo Image" required />
          <ReactInput name="circle_img" type="file" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Why Choose Us Image Front" required />
          <ReactInput name="img1" type="file" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Why Choose Us Image Back" required />
          <ReactInput name="img2" type="file" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Button Title" required />
          <ReactInput name="button_title" />
        </Form.Group>
      </Col>

      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Button Link" required />
          <ReactInput name="button_link" />
        </Form.Group>
      </Col>

      <Col sm={12}>
        <Form.Group className="mt-3">
          <FormLabel title="Description" required />
          <ReactTextEditor
            defaultData={values?.description}
            setEditorData={(val) => setFieldValue("description", val)}
          />
        </Form.Group>
      </Col>

      <Col sm={12}>
        <Form.Group className="mt-3">
          <FormLabel title="Experience" required />
          <ReactInput name="experience" />
        </Form.Group>
      </Col>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Box 1 Title" />
          <ReactInput name="box1Title" />
        </Form.Group>
      </Col>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Box 1 Description" />
          <ReactInput name="box1Description" />
        </Form.Group>
      </Col>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Box 2 Title" />
          <ReactInput name="box2Title" />
        </Form.Group>
      </Col>
      <Col sm={12} md={6}>
        <Form.Group className="mt-3">
          <FormLabel title="Box 2 Description" />
          <ReactInput name="box2Description" />
        </Form.Group>
      </Col>


      <div>
        <StatusCheck />
      </div>
    </Row>
  );
};

export default AboutUsForm;
